import { Inject, Injectable } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as bowser from 'bowser';
import { AmdWindowRef } from '../window-ref/window-ref.service';
import { AMD_MEDIA_QUERY } from './media-query.token';
export class AmdMediaQueryService {
    /**
     * @param {?} mediaQueries
     * @param {?} windowRef
     */
    constructor(mediaQueries, windowRef) {
        this.mediaQueries = mediaQueries;
        this.windowRef = windowRef;
        this.$mediaQuery = new BehaviorSubject(undefined);
        this.mediaQueryLists = new Map();
        this.onMediaQueryChanged = () => {
            this.$mediaQuery.next(undefined);
        };
        if (isPlatformServer(PLATFORM_ID)) {
            return;
        }
        for (let mediaQuery in this.mediaQueries) {
            if (this.mediaQueries.hasOwnProperty(mediaQuery)) {
                let mediaQueryList = this.windowRef.nativeWindow.matchMedia(this.mediaQueries[mediaQuery]);
                mediaQueryList.addListener(this.onMediaQueryChanged);
                this.mediaQueryLists.set(mediaQuery, mediaQueryList);
            }
        }
    }
    /**
     * @param {?} mediaQuery
     * @return {?}
     */
    checkMediaQuery(mediaQuery) {
        if (isPlatformServer(PLATFORM_ID)) {
            return false;
        }
        let /** @type {?} */ mediaQueryList = this.mediaQueryLists.get(mediaQuery);
        if (!mediaQueryList) {
            throw new Error('Unsupported media query');
        }
        return mediaQueryList.matches;
    }
    /**
     * @param {?} browser
     * @return {?}
     */
    checkBrowser(browser) {
        if (isPlatformServer(PLATFORM_ID)) {
            return false;
        }
        return bowser.test([browser]);
    }
    /**
     * @return {?}
     */
    isIe() {
        if (isPlatformServer(PLATFORM_ID)) {
            return false;
        }
        return bowser.msie;
    }
    /**
     * @return {?}
     */
    isEdge() {
        if (isPlatformServer(PLATFORM_ID)) {
            return false;
        }
        return bowser.msedge;
    }
}
AmdMediaQueryService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
AmdMediaQueryService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AMD_MEDIA_QUERY,] },] },
    { type: AmdWindowRef, },
];
function AmdMediaQueryService_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdMediaQueryService.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdMediaQueryService.ctorParameters;
    /** @type {?} */
    AmdMediaQueryService.prototype.$mediaQuery;
    /** @type {?} */
    AmdMediaQueryService.prototype.mediaQueryLists;
    /** @type {?} */
    AmdMediaQueryService.prototype.onMediaQueryChanged;
    /** @type {?} */
    AmdMediaQueryService.prototype.mediaQueries;
    /** @type {?} */
    AmdMediaQueryService.prototype.windowRef;
}
//# sourceMappingURL=media-query.service.js.map
//# sourceMappingURL=media-query.service.js.map
